export const SWR_REQUEST_CONFIG = {
  revalidateOnFocus: true, // повторная валидация данных при возвращении на вкладку
  dedupingInterval: 10000, // избегание повторных запросов
  keepPreviousData: true, // отдает предыдущие данные по ключу, пока новые данные загружаются
};

export const REVALIDATE_KEY = {
  MATERIAL_LIST: 'material_list',
  MATERIAL_ID: 'material_id',
  MATERIAL_CONTENT_URL: 'material_content_url',
  CATEGORY_LIST: 'category_list',
  CATEGORY: 'category',
  RATE_MATERIAL: 'rate_material',
  VARIABLE_LIST: 'variable_list',
  RECOMMENDED_LIST: 'recommended_list',
};
